// This file is generated by NTypewriter using scriban template (_Models.nt), DO NOT MODIFY THIS FILE
/* tslint:disable */
// @ts-ignore We don't have the means in codegen to determine if this symbol is actually used or not in the context of code we're about to emit so ignore unused warning.
import { ResourceModel } from './ResourceModel';
// @ts-ignore We don't have the means in codegen to determine if this symbol is actually used or not in the context of code we're about to emit so ignore unused warning.
import { DocumentResult } from './DocumentResult';
// @ts-ignore We don't have the means in codegen to determine if this symbol is actually used or not in the context of code we're about to emit so ignore unused warning.
import { ResourceCreateModel } from './ResourceCreateModel';
// @ts-ignore We don't have the means in codegen to determine if this symbol is actually used or not in the context of code we're about to emit so ignore unused warning.
import { DocumentPublishModel } from './DocumentPublishModel';
// @ts-ignore We don't have the means in codegen to determine if this symbol is actually used or not in the context of code we're about to emit so ignore unused warning.
import { BooleanValue } from './BooleanValue';

/**
 *  
 */
export class ResourceServiceClient {

    /**
     * get: api/Resource/${id}?includeDeleted=${includeDeleted}
     */
    public static RouteGetById = (id: number, includeDeleted: boolean) => `/api/Resource/${id}?includeDeleted=${includeDeleted}`;
    /**
     * Fetches the given document with the given id
     */
    public static async getById(id: number, includeDeleted: boolean): Promise<ResourceModel> {
        const url = ResourceServiceClient.RouteGetById(id, includeDeleted);
        const method: string = 'get';
        const data: any = null;
        const isFormData = false;
        const fetchParams: RequestInit = {
            method: method,
            credentials: 'same-origin'
        };
        if (method == "post") {
            if (isFormData) {
                const fd = new FormData();
                for (const key in data) {
                    fd.append(key, data[key]);
                }
                fetchParams.body = fd;
            } else {
                fetchParams.body = ((data && typeof(data) == 'string') ? data : JSON.stringify(data));
                var h = new Headers();
                h.append("Content-Type", "application/json");
                fetchParams.headers = h;
            }
        }
        const resp = await fetch(url, fetchParams);
        if (!resp.ok) {
            throw { statusCode: resp.status, resp }
        }
        return await resp.json();
    }

    /**
     * get: api/Resource/Find?query=${encodeURIComponent(query)}
     */
    public static RouteFind = (query: string) => `/api/Resource/Find?query=${encodeURIComponent(query)}`;
    /**
     * Fetches matching document based on the given search string
     */
    public static async find(query: string): Promise<ResourceModel[]> {
        const url = ResourceServiceClient.RouteFind(query);
        const method: string = 'get';
        const data: any = null;
        const isFormData = false;
        const fetchParams: RequestInit = {
            method: method,
            credentials: 'same-origin'
        };
        if (method == "post") {
            if (isFormData) {
                const fd = new FormData();
                for (const key in data) {
                    fd.append(key, data[key]);
                }
                fetchParams.body = fd;
            } else {
                fetchParams.body = ((data && typeof(data) == 'string') ? data : JSON.stringify(data));
                var h = new Headers();
                h.append("Content-Type", "application/json");
                fetchParams.headers = h;
            }
        }
        const resp = await fetch(url, fetchParams);
        if (!resp.ok) {
            throw { statusCode: resp.status, resp }
        }
        return await resp.json();
    }

    /**
     * post: api/Resource
     */
    public static RouteCreate = () => `/api/Resource`;
    /**
     * Creates a new document
     */
    public static async create(model: ResourceCreateModel): Promise<DocumentResult> {
        const url = ResourceServiceClient.RouteCreate();
        const method: string = 'post';
        const data: any = model;
        const isFormData = false;
        const fetchParams: RequestInit = {
            method: method,
            credentials: 'same-origin'
        };
        if (method == "post") {
            if (isFormData) {
                const fd = new FormData();
                for (const key in data) {
                    fd.append(key, data[key]);
                }
                fetchParams.body = fd;
            } else {
                fetchParams.body = ((data && typeof(data) == 'string') ? data : JSON.stringify(data));
                var h = new Headers();
                h.append("Content-Type", "application/json");
                fetchParams.headers = h;
            }
        }
        const resp = await fetch(url, fetchParams);
        if (!resp.ok) {
            throw { statusCode: resp.status, resp }
        }
        return await resp.json();
    }

    /**
     * post: api/Resource/edit
     */
    public static RouteUpdate = () => `/api/Resource/edit`;
    /**
     * Updates an existing document
     */
    public static async update(model: ResourceModel): Promise<DocumentResult> {
        const url = ResourceServiceClient.RouteUpdate();
        const method: string = 'post';
        const data: any = model;
        const isFormData = false;
        const fetchParams: RequestInit = {
            method: method,
            credentials: 'same-origin'
        };
        if (method == "post") {
            if (isFormData) {
                const fd = new FormData();
                for (const key in data) {
                    fd.append(key, data[key]);
                }
                fetchParams.body = fd;
            } else {
                fetchParams.body = ((data && typeof(data) == 'string') ? data : JSON.stringify(data));
                var h = new Headers();
                h.append("Content-Type", "application/json");
                fetchParams.headers = h;
            }
        }
        const resp = await fetch(url, fetchParams);
        if (!resp.ok) {
            throw { statusCode: resp.status, resp }
        }
        return await resp.json();
    }

    /**
     * post: api/Resource/Publish
     */
    public static RoutePublish = () => `/api/Resource/Publish`;
    /**
     * Publishes the given document
     */
    public static async publish(input: DocumentPublishModel): Promise<ResourceModel> {
        const url = ResourceServiceClient.RoutePublish();
        const method: string = 'post';
        const data: any = input;
        const isFormData = false;
        const fetchParams: RequestInit = {
            method: method,
            credentials: 'same-origin'
        };
        if (method == "post") {
            if (isFormData) {
                const fd = new FormData();
                for (const key in data) {
                    fd.append(key, data[key]);
                }
                fetchParams.body = fd;
            } else {
                fetchParams.body = ((data && typeof(data) == 'string') ? data : JSON.stringify(data));
                var h = new Headers();
                h.append("Content-Type", "application/json");
                fetchParams.headers = h;
            }
        }
        const resp = await fetch(url, fetchParams);
        if (!resp.ok) {
            throw { statusCode: resp.status, resp }
        }
        return await resp.json();
    }

    /**
     * post: api/Resource/Delete?id=${id}
     */
    public static RouteDelete = (id: number) => `/api/Resource/Delete?id=${id}`;
    /**
     * Deletes an existing document entry by its id
     */
    public static async delete(id: number): Promise<BooleanValue> {
        const url = ResourceServiceClient.RouteDelete(id);
        const method: string = 'post';
        const data: any = null;
        const isFormData = false;
        const fetchParams: RequestInit = {
            method: method,
            credentials: 'same-origin'
        };
        if (method == "post") {
            if (isFormData) {
                const fd = new FormData();
                for (const key in data) {
                    fd.append(key, data[key]);
                }
                fetchParams.body = fd;
            } else {
                fetchParams.body = ((data && typeof(data) == 'string') ? data : JSON.stringify(data));
                var h = new Headers();
                h.append("Content-Type", "application/json");
                fetchParams.headers = h;
            }
        }
        const resp = await fetch(url, fetchParams);
        if (!resp.ok) {
            throw { statusCode: resp.status, resp }
        }
        return await resp.json();
    }

}

/**
 *  
 */
export class ResourceRequestFactory {

    /**
     * get: api/Resource/${id}?includeDeleted=${includeDeleted}
     */
    public static RouteGetById = (id: number, includeDeleted: boolean) => `/api/Resource/${id}?includeDeleted=${includeDeleted}`;
    /**
     * Fetches the given document with the given id
     */
    public static async getById(fetcher: (url: string, init: RequestInit) => Promise<Response>, id: number, includeDeleted: boolean): Promise<ResourceModel> {
        const url = ResourceServiceClient.RouteGetById(id, includeDeleted);
        const method: string = 'get';
        const data: any = null;
        const isFormData = false;
        const fetchParams: RequestInit = {
            method: method,
            credentials: 'same-origin'
        };
        if (method == "post") {
            if (isFormData) {
                const fd = new FormData();
                for (const key in data) {
                    fd.append(key, data[key]);
                }
                fetchParams.body = fd;
            } else {
                fetchParams.body = ((data && typeof(data) == 'string') ? data : JSON.stringify(data));
                var h = new Headers();
                h.append("Content-Type", "application/json");
                fetchParams.headers = h;
            }
        }
        const resp = await fetcher(url, fetchParams);
        if (!resp.ok) {
            throw { statusCode: resp.status, resp }
        }
        return await resp.json();
    }

    /**
     * get: api/Resource/Find?query=${encodeURIComponent(query)}
     */
    public static RouteFind = (query: string) => `/api/Resource/Find?query=${encodeURIComponent(query)}`;
    /**
     * Fetches matching document based on the given search string
     */
    public static async find(fetcher: (url: string, init: RequestInit) => Promise<Response>, query: string): Promise<ResourceModel[]> {
        const url = ResourceServiceClient.RouteFind(query);
        const method: string = 'get';
        const data: any = null;
        const isFormData = false;
        const fetchParams: RequestInit = {
            method: method,
            credentials: 'same-origin'
        };
        if (method == "post") {
            if (isFormData) {
                const fd = new FormData();
                for (const key in data) {
                    fd.append(key, data[key]);
                }
                fetchParams.body = fd;
            } else {
                fetchParams.body = ((data && typeof(data) == 'string') ? data : JSON.stringify(data));
                var h = new Headers();
                h.append("Content-Type", "application/json");
                fetchParams.headers = h;
            }
        }
        const resp = await fetcher(url, fetchParams);
        if (!resp.ok) {
            throw { statusCode: resp.status, resp }
        }
        return await resp.json();
    }

    /**
     * post: api/Resource
     */
    public static RouteCreate = () => `/api/Resource`;
    /**
     * Creates a new document
     */
    public static async create(fetcher: (url: string, init: RequestInit) => Promise<Response>, model: ResourceCreateModel): Promise<DocumentResult> {
        const url = ResourceServiceClient.RouteCreate();
        const method: string = 'post';
        const data: any = model;
        const isFormData = false;
        const fetchParams: RequestInit = {
            method: method,
            credentials: 'same-origin'
        };
        if (method == "post") {
            if (isFormData) {
                const fd = new FormData();
                for (const key in data) {
                    fd.append(key, data[key]);
                }
                fetchParams.body = fd;
            } else {
                fetchParams.body = ((data && typeof(data) == 'string') ? data : JSON.stringify(data));
                var h = new Headers();
                h.append("Content-Type", "application/json");
                fetchParams.headers = h;
            }
        }
        const resp = await fetcher(url, fetchParams);
        if (!resp.ok) {
            throw { statusCode: resp.status, resp }
        }
        return await resp.json();
    }

    /**
     * post: api/Resource/edit
     */
    public static RouteUpdate = () => `/api/Resource/edit`;
    /**
     * Updates an existing document
     */
    public static async update(fetcher: (url: string, init: RequestInit) => Promise<Response>, model: ResourceModel): Promise<DocumentResult> {
        const url = ResourceServiceClient.RouteUpdate();
        const method: string = 'post';
        const data: any = model;
        const isFormData = false;
        const fetchParams: RequestInit = {
            method: method,
            credentials: 'same-origin'
        };
        if (method == "post") {
            if (isFormData) {
                const fd = new FormData();
                for (const key in data) {
                    fd.append(key, data[key]);
                }
                fetchParams.body = fd;
            } else {
                fetchParams.body = ((data && typeof(data) == 'string') ? data : JSON.stringify(data));
                var h = new Headers();
                h.append("Content-Type", "application/json");
                fetchParams.headers = h;
            }
        }
        const resp = await fetcher(url, fetchParams);
        if (!resp.ok) {
            throw { statusCode: resp.status, resp }
        }
        return await resp.json();
    }

    /**
     * post: api/Resource/Publish
     */
    public static RoutePublish = () => `/api/Resource/Publish`;
    /**
     * Publishes the given document
     */
    public static async publish(fetcher: (url: string, init: RequestInit) => Promise<Response>, input: DocumentPublishModel): Promise<ResourceModel> {
        const url = ResourceServiceClient.RoutePublish();
        const method: string = 'post';
        const data: any = input;
        const isFormData = false;
        const fetchParams: RequestInit = {
            method: method,
            credentials: 'same-origin'
        };
        if (method == "post") {
            if (isFormData) {
                const fd = new FormData();
                for (const key in data) {
                    fd.append(key, data[key]);
                }
                fetchParams.body = fd;
            } else {
                fetchParams.body = ((data && typeof(data) == 'string') ? data : JSON.stringify(data));
                var h = new Headers();
                h.append("Content-Type", "application/json");
                fetchParams.headers = h;
            }
        }
        const resp = await fetcher(url, fetchParams);
        if (!resp.ok) {
            throw { statusCode: resp.status, resp }
        }
        return await resp.json();
    }

    /**
     * post: api/Resource/Delete?id=${id}
     */
    public static RouteDelete = (id: number) => `/api/Resource/Delete?id=${id}`;
    /**
     * Deletes an existing document entry by its id
     */
    public static async delete(fetcher: (url: string, init: RequestInit) => Promise<Response>, id: number): Promise<BooleanValue> {
        const url = ResourceServiceClient.RouteDelete(id);
        const method: string = 'post';
        const data: any = null;
        const isFormData = false;
        const fetchParams: RequestInit = {
            method: method,
            credentials: 'same-origin'
        };
        if (method == "post") {
            if (isFormData) {
                const fd = new FormData();
                for (const key in data) {
                    fd.append(key, data[key]);
                }
                fetchParams.body = fd;
            } else {
                fetchParams.body = ((data && typeof(data) == 'string') ? data : JSON.stringify(data));
                var h = new Headers();
                h.append("Content-Type", "application/json");
                fetchParams.headers = h;
            }
        }
        const resp = await fetcher(url, fetchParams);
        if (!resp.ok) {
            throw { statusCode: resp.status, resp }
        }
        return await resp.json();
    }

}


// WEBPACK FOOTER //
// ./src/model/autogen/ResourceController.ts